// extracted by mini-css-extract-plugin
export default {"Icon":"ResizeHandle_Icon__gCCtM","Handle":"ResizeHandle_Handle__Kb5U1"};